import { render, staticRenderFns } from "./VehiclesCatalog.vue?vue&type=template&id=0b43e31d"
import script from "./VehiclesCatalog.vue?vue&type=script&lang=js"
export * from "./VehiclesCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports